import React, { Component } from 'react';

import LeafletMapCarFleet from '../b-LeafletMap/LeafletMapCarFleet';

import Sources from '../f-Utilities/Sources'

class CarFleet extends React.Component {
  constructor(props) {
    super(props);

    var communes = this.props.territory.communes;
    var communes_wd = communes.filter((c) => c.critair != null)

    var selected = ["critair1", "critair2", "elec"]
    var selected_labels = selected.map((s)=>communes_wd[0].critair[s].label).join(", ")

    var sum_masses = communes_wd.map((c)=>Object.keys(c.critair).map(
        (crit) => c.critair[crit]["value"]).reduce((a, b) => a + b, 0))
    var sum_selected_masses = communes_wd.map((c)=> Object.keys(c.critair).filter(
      (crit) => selected.includes(crit)).map(
        (crit) => c.critair[crit]["value"]).reduce((a, b) => a + b, 0))
    var prop_masses = communes_wd.map((c, i)=> Math.round(sum_selected_masses[i]/sum_masses[i]*100))
    var labels = communes_wd.map((c, i) => "<b>" + c.name + "</b></br>" + sum_selected_masses[i].toLocaleString("fr-FR") + " véhicules " + selected_labels + "</br><i>" + prop_masses[i] + "% du parc</i>");

    this.state = {
      selected: selected,
      masses: prop_masses,
      labels: labels,
      legend_label: "(part des véhicules " + selected_labels + " - %)",
    };
  }

  displayCategory = (selected) => {
      this.setState(function(state, props) {
        let index = state.selected.indexOf(selected);
        let l_selected = [];
        if (index > -1) {
          l_selected = state.selected
          l_selected.splice(index, 1) // 2nd parameter means remove one item only
        }
        else{
          l_selected = state.selected.concat([selected])
        }

        var communes = props.territory.communes
        var communes_wd = communes.filter((c) => c.critair != null)

        var selected_labels = l_selected.map((s)=>communes_wd[0].critair[s].label).sort().join(", ")

        var sum_masses = communes_wd.map((c)=>Object.keys(c.critair).map(
            (crit) => c.critair[crit]["value"]).reduce((a, b) => a + b, 0))
        var sum_selected_masses = communes_wd.map((c)=> Object.keys(c.critair).filter(
          (crit) => l_selected.includes(crit)).map(
            (crit) => c.critair[crit]["value"]).reduce((a, b) => a + b, 0))
        var prop_masses = communes_wd.map((c, i)=> Math.round(sum_selected_masses[i]/sum_masses[i]*100))
        var labels = communes_wd.map((c, i) => "<b>" + c.name + "</b></br>" + sum_selected_masses[i].toLocaleString("fr-FR") + " véhicules " + selected_labels + "</br><i>" + prop_masses[i] + "% du parc</i>");

        return {
          selected: l_selected,
          masses: prop_masses,
          labels: labels,
          legend_label: "(part des véhicules " + selected_labels + " - %)",
        };
      });
  }

  render() {
    var communes = this.props.territory.communes;
    var communes_nd = communes.filter((c) => c.critair == null)
    var missing_data = communes_nd.length > 0
    var communes_wd = communes.filter((c) => c.critair != null)


    var critair_labels = {};
    Object.keys(communes[0].critair).map((key) => critair_labels[key] = communes_wd[0].critair[key]["label"])

    return(
          <div className="row content">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">parc de véhicules</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                     <p className="mb-2" id="population"><i>Vignettes Crit'Air :</i></p>

                     {Object.keys(critair_labels).map((critair_key, i)=>
                       <div className="form-check">
                         <input className="form-check-input ml-0 mt-2" type="checkbox" value={critair_key} id={"defaultCheck" + i}
                         checked={this.state.selected.includes(critair_key)}
                          onChange={ this.displayCategory.bind(this, critair_key) }  />
                         <label className="form-check-label" for={"defaultCheck" + i}>
                           <p>{critair_labels[critair_key]}</p>
                         </label>
                        </div>
                     )}


                  </div>

                </div>
            </div>

            <div className="col-9">
                <LeafletMapCarFleet communes_wd={communes_wd}
                                    communes_nd={communes_nd}
                                    communes={communes}
                                   masses={this.state.masses}
                                   labels={this.state.labels}
                                   selected={this.state.selected}
                                   legend_label={this.state.legend_label}
                                   missing_data={missing_data}
                                   id="car_fleet"/>

               <div className="row mt-1">
                 <div className="col-10">
                  <Sources sources={this.props.territory.sources}
                         concerned={["critair"]}/>
                 </div>
               </div>
            </div>

          </div>
    )
  }
}

export default CarFleet;
